<div class="rt-card" [class.rt-card-clickable]="!disabled">
  <rt-checkbox
    *ngIf="description; else withoutDescription"
    [formControl]="control"
    [disabled]="disabled"
    (valueChange)="valueChanges.emit($event)"
    padding
    layout-full-width
  >
    <strong layout>
      {{ label }}
    </strong>
    <span class="description" [innerHTML]="description"></span>
  </rt-checkbox>
</div>
<ng-template #withoutDescription>
  <rt-checkbox
    [formControl]="control"
    [disabled]="disabled"
    (valueChange)="valueChanges.emit($event)"
    padding-small-x
    layout-full-width
  >
    <span>
      {{ label }}
    </span>
  </rt-checkbox>
</ng-template>
